import BigActivism from "../../../assets/images/icons/controlRisksIncidents/maritime/big/Activism.svg";
import BigAssault from "../../../assets/images/icons/controlRisksIncidents/maritime/big/Assault.svg";
import BigAttempt from "../../../assets/images/icons/controlRisksIncidents/maritime/big/Attempt.svg";
import BigHijacking from "../../../assets/images/icons/controlRisksIncidents/maritime/big/Hijacking.svg";
import BigKidnapping from "../../../assets/images/icons/controlRisksIncidents/maritime/big/Kidnapping.svg";
import BigRobbery from "../../../assets/images/icons/controlRisksIncidents/maritime/big/Robbery.svg";
import BigStateAction from "../../../assets/images/icons/controlRisksIncidents/maritime/big/StateAction.svg";
import BigSuspicious from "../../../assets/images/icons/controlRisksIncidents/maritime/big/Suspicious.svg";
import BigTerrorism from "../../../assets/images/icons/controlRisksIncidents/maritime/big/Terrorism.svg";
import BigTheft from "../../../assets/images/icons/controlRisksIncidents/maritime/big/Theft.svg";

import MapActivism from "../../../assets/images/icons/controlRisksIncidents/maritime/map/Activism.svg";
import MapAssault from "../../../assets/images/icons/controlRisksIncidents/maritime/map/Assault.svg";
import MapAttempt from "../../../assets/images/icons/controlRisksIncidents/maritime/map/Attempt.svg";
import MapHijacking from "../../../assets/images/icons/controlRisksIncidents/maritime/map/Hijacking.svg";
import MapKidnapping from "../../../assets/images/icons/controlRisksIncidents/maritime/map/Kidnapping.svg";
import MapRobbery from "../../../assets/images/icons/controlRisksIncidents/maritime/map/Robbery.svg";
import MapStateAction from "../../../assets/images/icons/controlRisksIncidents/maritime/map/StateAction.svg";
import MapSuspicious from "../../../assets/images/icons/controlRisksIncidents/maritime/map/Suspicious.svg";
import MapTerrorism from "../../../assets/images/icons/controlRisksIncidents/maritime/map/Terrorism.svg";
import MapTheft from "../../../assets/images/icons/controlRisksIncidents/maritime/map/Theft.svg";

export default [
  {
    Id: 34,
    Name: "Activism",
    Discriminator: "MaritimeCategory",
    Icons: {
      Big: BigActivism,
      Map: MapActivism,
    },
  },
  {
    Id: 36,
    Name: "Assault",
    Discriminator: "MaritimeCategory",
    Icons: {
      Big: BigAssault,
      Map: MapAssault,
    },
  },
  {
    Id: 37,
    Name: "Attempt",
    Discriminator: "MaritimeCategory",
    Icons: {
      Big: BigAttempt,
      Map: MapAttempt,
    },
  },
  {
    Id: 38,
    Name: "Hijack",
    Discriminator: "MaritimeCategory",
    Icons: {
      Big: BigHijacking,
      Map: MapHijacking,
    },
  },
  {
    Id: 39,
    Name: "Kidnap",
    Discriminator: "MaritimeCategory",
    Icons: {
      Big: BigKidnapping,
      Map: MapKidnapping,
    },
  },
  {
    Id: 40,
    Name: "Robbery",
    Discriminator: "MaritimeCategory",
    Icons: {
      Big: BigRobbery,
      Map: MapRobbery,
    },
  },
  {
    Id: 41,
    Name: "Suspicious Activity",
    Discriminator: "MaritimeCategory",
    Icons: {
      Big: BigSuspicious,
      Map: MapSuspicious,
    },
  },
  {
    Id: 42,
    Name: "Terrorism",
    Discriminator: "MaritimeCategory",
    Icons: {
      Big: BigTerrorism,
      Map: MapTerrorism,
    },
  },
  {
    Id: 43,
    Name: "Theft",
    Discriminator: "MaritimeCategory",
    Icons: {
      Big: BigTheft,
      Map: MapTheft,
    },
  },
  {
    Id: 46,
    Name: "State Action",
    Discriminator: "MaritimeCategory",
    Icons: {
      Big: BigStateAction,
      Map: MapStateAction,
    },
  },
];
